import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "table-row" }
const _hoisted_2 = { class: "table-row-left" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "table-row-right" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

import { Feature } from "../classes/feature";

import { Product } from "../classes/product";

interface Props {
  product: Product;
  feature: Feature;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ListContentRowComponent',
  props: {
    product: {},
    feature: { default: null }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        innerHTML: props.feature.value
      }, null, 8, _hoisted_3),
      (props.feature.subValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "text-small",
            innerHTML: props.feature.subValue || props.feature.description
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (
          typeof props.product.getFeatureValue(props.feature.id)?.value ===
          'string'
        )
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: props.product.getFeatureValue(props.feature.id)?.value
          }, null, 8, _hoisted_6))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({
          'agila-icon-check':
            props.product.getFeatureValue(props.feature.id)?.value === true,
          'agila-icon-skip':
            props.product.getFeatureValue(props.feature.id)?.value === false,
        })
          }, null, 2)),
      (props.product.getFeatureValue(props.feature.id)?.subValue)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "text-small",
            innerHTML: 
          props.product.getFeatureValue(props.feature.id)?.subValue ||
          props.product.getFeatureValue(props.feature.id)?.description
        
          }, null, 8, _hoisted_7))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})